var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMatchPrecision(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.09,138.86c-11.22,6.32-20.31,22.07-20.31,35.17s9.09,18.48,20.31,12,20.31-22.22,20.31-35.18S188.3,132.53,177.09,138.86Z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.75,412.85c84.08,43.93,220.42,43.93,304.5,0s84.09-115.15,0-159.08-220.42-43.93-304.5,0S13.66,368.92,97.75,412.85Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 315.71,
    cy: 379.86,
    rx: 45.91,
    ry: 21.88,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 397.04,
    cy: 334.96,
    rx: 35.42,
    ry: 16.88,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.59,330.23c-2-10.56-9.32-25.61-18.25-34-8.59-8.06-21.34-10.87-26.42-7.15s-1.75,11.76,8.11,21.56c11.13,11.05,32.5,41.71,36.56,59.08Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.59,330.23c-2-10.56-9.32-25.61-18.25-34-8.59-8.06-21.34-10.87-26.42-7.15s-1.75,11.76,8.11,21.56c11.13,11.05,32.5,41.71,36.56,59.08Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M144.59,355.64a.51.51,0,0,1-.5-.46c-2.52-26.6-21.12-56.5-39-62.73a.51.51,0,0,1-.31-.64.51.51,0,0,1,.64-.31c18.54,6.45,37.09,36.17,39.69,63.59a.51.51,0,0,1-.45.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.59,382.49s-3.46,2.76-15,1.68-17.49-9.33-17.49-12.87,10.61-4.15,12.91-12.93a15.34,15.34,0,0,1-8.84,4.69c-6,1.13-10.82-.79-12.19-11.72a19.6,19.6,0,0,0,8.82-.73c4.75-1.53,5.88-4.14,4.64-4.7s-7.86,0-12.1-1.61-1-23.69,1.78-25.26,15.93,2.13,18.49,4.11c2.28,1.76,5.48,4.81,4,11.26a16.17,16.17,0,0,0,4-5.88c1.24-3,2.14-2.3,4-1.15a9,9,0,0,1,4.39,6c.45,2.8-.28,12.46-4.22,15.6,0,0,3.78.48,6.87-5.9,0,0,6,2.42,7.36,6.34S154.85,372.53,144.59,382.49Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.61,384.67a.51.51,0,0,1-.5-.44c-2.64-21.61-19.07-50-35.18-60.66a.5.5,0,0,1,.56-.84c16.31,10.85,33,39.53,35.61,61.38a.5.5,0,0,1-.43.56Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.62,387.69a4.65,4.65,0,0,1-2-3.67V145.11a4.78,4.78,0,0,1,2.17-3.75l150-86.62a4.07,4.07,0,0,1,6.23,3.6L150.82,387.61A4.64,4.64,0,0,1,146.62,387.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.65,149.65l60.93-39.87-4.06-2.35-58.76,33.93a4.78,4.78,0,0,0-2.17,3.75v2.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.65,149.65l60.93-39.87-4.06-2.35-58.76,33.93a4.78,4.78,0,0,0-2.17,3.75v2.19Z",
    style: {
      fill: "#37474f",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,156.68,145.22,143a4.43,4.43,0,0,0-.63,2.13V384a4.07,4.07,0,0,0,6.23,3.59L169,377.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,156.68,145.22,143a4.43,4.43,0,0,0-.63,2.13V384a4.07,4.07,0,0,0,6.23,3.59L169,377.14Z",
    style: {
      fill: "#263238",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.82,387.61l150-86.62a4.78,4.78,0,0,0,2.17-3.75V58.34c0-1.38-1-1.94-2.17-1.25l-150,86.62a4.78,4.78,0,0,0-2.17,3.75v238.9C148.65,387.74,149.62,388.3,150.82,387.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.82,387.61l150-86.62a4.78,4.78,0,0,0,2.17-3.75V58.34c0-1.38-1-1.94-2.17-1.25l-150,86.62a4.78,4.78,0,0,0-2.17,3.75v238.9C148.65,387.74,149.62,388.3,150.82,387.61Z",
    style: {
      fill: "#455a64",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.11,202.64l36-20.8c2.39-1.38,4.33-.4,4.33,2.19a9.29,9.29,0,0,1-4.33,7.19l-36,20.8c-2.4,1.38-4.33.4-4.33-2.19A9.26,9.26,0,0,1,161.11,202.64Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.11,217.4l23.83-13.76c2.39-1.38,4.33-.4,4.33,2.19a9.29,9.29,0,0,1-4.33,7.19l-23.83,13.76c-2.4,1.38-4.33.4-4.33-2.19A9.26,9.26,0,0,1,161.11,217.4Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.51,242.66l4.66-2.69c1-.55,1.73-.1,1.73,1v5.38a3.83,3.83,0,0,1-1.73,3L158.51,252c-1,.56-1.73.11-1.73-1v-5.38A3.84,3.84,0,0,1,158.51,242.66Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.51,242.66l4.66-2.69c1-.55,1.73-.1,1.73,1v5.38a3.83,3.83,0,0,1-1.73,3L158.51,252c-1,.56-1.73.11-1.73-1v-5.38A3.84,3.84,0,0,1,158.51,242.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.51,261.43l4.66-2.69c1-.56,1.73-.11,1.73,1v5.38a3.86,3.86,0,0,1-1.73,3l-4.66,2.69c-1,.55-1.73.1-1.73-1v-5.38A3.81,3.81,0,0,1,158.51,261.43Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.51,261.43l4.66-2.69c1-.56,1.73-.11,1.73,1v5.38a3.86,3.86,0,0,1-1.73,3l-4.66,2.69c-1,.55-1.73.1-1.73-1v-5.38A3.81,3.81,0,0,1,158.51,261.43Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M171.13,256.49l28.16-16.27c1.2-.69,2.17-.2,2.17,1.1a4.64,4.64,0,0,1-2.17,3.59l-28.16,16.27c-1.2.69-2.17.2-2.17-1.1A4.64,4.64,0,0,1,171.13,256.49Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.13,256.49l28.16-16.27c1.2-.69,2.17-.2,2.17,1.1a4.64,4.64,0,0,1-2.17,3.59l-28.16,16.27c-1.2.69-2.17.2-2.17-1.1A4.64,4.64,0,0,1,171.13,256.49Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.51,280.19l4.66-2.69c1-.56,1.73-.11,1.73,1v5.38a3.85,3.85,0,0,1-1.73,3l-4.66,2.69c-1,.55-1.73.1-1.73-1v-5.38A3.81,3.81,0,0,1,158.51,280.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.13,275.25,199.29,259c1.2-.69,2.17-.2,2.17,1.1a4.62,4.62,0,0,1-2.17,3.59l-28.16,16.27c-1.2.69-2.17.2-2.17-1.1A4.64,4.64,0,0,1,171.13,275.25Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.51,299l4.66-2.69c1-.56,1.73-.11,1.73,1v5.38a3.85,3.85,0,0,1-1.73,3l-4.66,2.69c-1,.55-1.73.1-1.73-1V302A3.81,3.81,0,0,1,158.51,299Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.13,294.06l28.16-16.26c1.2-.7,2.17-.2,2.17,1.09a4.64,4.64,0,0,1-2.17,3.6l-28.16,16.26c-1.2.69-2.17.2-2.17-1.1A4.64,4.64,0,0,1,171.13,294.06Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.51,317.76l4.66-2.69c1-.56,1.73-.11,1.73,1v5.38a3.85,3.85,0,0,1-1.73,3l-4.66,2.69c-1,.55-1.73.1-1.73-1v-5.38A3.81,3.81,0,0,1,158.51,317.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.13,312.82l28.16-16.26c1.2-.7,2.17-.2,2.17,1.09a4.64,4.64,0,0,1-2.17,3.6l-28.16,16.26c-1.2.69-2.17.2-2.17-1.1A4.64,4.64,0,0,1,171.13,312.82Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.94,336.22l20-11.57c1.2-.69,2.17-.2,2.17,1.1a4.64,4.64,0,0,1-2.17,3.59l-20,11.57c-1.19.69-2.16.2-2.16-1.09A4.65,4.65,0,0,1,158.94,336.22Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.94,345.6l40.35-23.29c1.2-.69,2.17-.2,2.17,1.09a4.64,4.64,0,0,1-2.17,3.6l-40.35,23.29c-1.19.69-2.16.2-2.16-1.09A4.65,4.65,0,0,1,158.94,345.6Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.94,345.6l40.35-23.29c1.2-.69,2.17-.2,2.17,1.09a4.64,4.64,0,0,1-2.17,3.6l-40.35,23.29c-1.19.69-2.16.2-2.16-1.09A4.65,4.65,0,0,1,158.94,345.6Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.94,345.6l28.17-16.26c1.19-.69,2.16-.2,2.16,1.1a4.65,4.65,0,0,1-2.16,3.59l-28.17,16.26c-1.19.69-2.16.2-2.16-1.09A4.65,4.65,0,0,1,158.94,345.6Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.94,355l20-11.57c1.2-.69,2.17-.2,2.17,1.1a4.64,4.64,0,0,1-2.17,3.59l-20,11.57c-1.19.69-2.16.2-2.16-1.09A4.65,4.65,0,0,1,158.94,355Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.13,237.72l28.16-16.26c1.2-.69,2.17-.2,2.17,1.1a4.64,4.64,0,0,1-2.17,3.59l-28.16,16.26c-1.2.69-2.17.2-2.17-1.09A4.64,4.64,0,0,1,171.13,237.72Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.13,237.72l28.16-16.26c1.2-.69,2.17-.2,2.17,1.1a4.64,4.64,0,0,1-2.17,3.59l-28.16,16.26c-1.2.69-2.17.2-2.17-1.09A4.64,4.64,0,0,1,171.13,237.72Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.94,355l20-11.57c1.2-.69,2.17-.2,2.17,1.1a4.64,4.64,0,0,1-2.17,3.59l-20,11.57c-1.19.69-2.16.2-2.16-1.09A4.65,4.65,0,0,1,158.94,355Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.94,364.35l40.35-23.29c1.2-.69,2.17-.2,2.17,1.09a4.64,4.64,0,0,1-2.17,3.6L158.94,369c-1.19.7-2.16.2-2.16-1.09A4.65,4.65,0,0,1,158.94,364.35Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.94,364.35l40.35-23.29c1.2-.69,2.17-.2,2.17,1.09a4.64,4.64,0,0,1-2.17,3.6L158.94,369c-1.19.7-2.16.2-2.16-1.09A4.65,4.65,0,0,1,158.94,364.35Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.94,364.35l36.29-21c1.2-.69,2.17-.2,2.17,1.1a4.64,4.64,0,0,1-2.17,3.59l-36.29,21c-1.19.7-2.16.2-2.16-1.09A4.65,4.65,0,0,1,158.94,364.35Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.84,57.09l-91.26,52.69v243.9L300.84,301a4.78,4.78,0,0,0,2.17-3.75V58.34C303,57,302,56.4,300.84,57.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.84,57.09l-91.26,52.69v243.9L300.84,301a4.78,4.78,0,0,0,2.17-3.75V58.34C303,57,302,56.4,300.84,57.09Z",
    style: {
      fill: "#fafafa",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.58 119.16 209.58 137.92 201.46 147.3 209.58 147.3 209.58 166.06 294.88 116.81 294.88 69.91 209.58 119.16",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.74,119.81l34.56-20c1.67-1,3-.18,3,1.75v0a6.72,6.72,0,0,1-3,5.25l-34.56,19.95c-1.68,1-3,.18-3-1.75v0A6.69,6.69,0,0,1,220.74,119.81Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M218.79,135l66.89-38.62c.6-.34,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8L218.79,137.3c-.6.34-1.08.1-1.08-.55A2.32,2.32,0,0,1,218.79,135Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.79,135l66.89-38.62c.6-.34,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8L218.79,137.3c-.6.34-1.08.1-1.08-.55A2.32,2.32,0,0,1,218.79,135Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.79,135l66.89-38.62c.6-.34,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8L218.79,137.3c-.6.34-1.08.1-1.08-.55A2.32,2.32,0,0,1,218.79,135Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.79,142l66.89-38.62c.6-.35,1.08-.1,1.08.55a2.3,2.3,0,0,1-1.08,1.79l-66.89,38.62c-.6.35-1.08.1-1.08-.55A2.3,2.3,0,0,1,218.79,142Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.79,142l66.89-38.62c.6-.35,1.08-.1,1.08.55a2.3,2.3,0,0,1-1.08,1.79l-66.89,38.62c-.6.35-1.08.1-1.08-.55A2.3,2.3,0,0,1,218.79,142Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.79,149l66.89-38.62c.6-.34,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8l-66.89,38.62c-.6.34-1.08.1-1.08-.55A2.32,2.32,0,0,1,218.79,149Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.31,168.7,226,166c1-.56,1.73-.11,1.73,1v5.38a3.84,3.84,0,0,1-1.73,3l-4.66,2.69c-1,.55-1.73.1-1.73-1V171.7A3.81,3.81,0,0,1,221.31,168.7Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.31,168.7,226,166c1-.56,1.73-.11,1.73,1v5.38a3.84,3.84,0,0,1-1.73,3l-4.66,2.69c-1,.55-1.73.1-1.73-1V171.7A3.81,3.81,0,0,1,221.31,168.7Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.93,163.76l28.16-16.27c1.2-.69,2.17-.2,2.17,1.1a4.64,4.64,0,0,1-2.17,3.59l-28.16,16.27c-1.2.69-2.17.2-2.17-1.1A4.64,4.64,0,0,1,233.93,163.76Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.93,163.76l28.16-16.27c1.2-.69,2.17-.2,2.17,1.1a4.64,4.64,0,0,1-2.17,3.59l-28.16,16.27c-1.2.69-2.17.2-2.17-1.1A4.64,4.64,0,0,1,233.93,163.76Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,185.5l71-41c.6-.35,1.08-.1,1.08.54a2.31,2.31,0,0,1-1.08,1.8l-71,41c-.6.35-1.08.1-1.08-.55A2.3,2.3,0,0,1,220.66,185.5Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,192.53l71-41c.6-.34,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8l-71,41c-.6.34-1.08.1-1.08-.55A2.32,2.32,0,0,1,220.66,192.53Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,199.57l71-41c.6-.35,1.08-.1,1.08.54a2.31,2.31,0,0,1-1.08,1.8l-71,41c-.6.35-1.08.1-1.08-.54A2.31,2.31,0,0,1,220.66,199.57Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,206.62l71-41c.6-.34,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8l-71,41c-.6.34-1.08.1-1.08-.55A2.32,2.32,0,0,1,220.66,206.62Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,185.5l71-41c.6-.35,1.08-.1,1.08.54a2.31,2.31,0,0,1-1.08,1.8l-71,41c-.6.35-1.08.1-1.08-.55A2.3,2.3,0,0,1,220.66,185.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,192.53l71-41c.6-.34,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8l-71,41c-.6.34-1.08.1-1.08-.55A2.32,2.32,0,0,1,220.66,192.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,199.57l71-41c.6-.35,1.08-.1,1.08.54a2.31,2.31,0,0,1-1.08,1.8l-71,41c-.6.35-1.08.1-1.08-.54A2.31,2.31,0,0,1,220.66,199.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,206.62l71-41c.6-.34,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8l-71,41c-.6.34-1.08.1-1.08-.55A2.32,2.32,0,0,1,220.66,206.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,185.5l71-41c.6-.35,1.08-.1,1.08.54a2.31,2.31,0,0,1-1.08,1.8l-71,41c-.6.35-1.08.1-1.08-.55A2.3,2.3,0,0,1,220.66,185.5Z",
    style: {
      fill: "#e0e0e0",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,192.53l71-41c.6-.34,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8l-71,41c-.6.34-1.08.1-1.08-.55A2.32,2.32,0,0,1,220.66,192.53Z",
    style: {
      fill: "#e0e0e0",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,199.57l71-41c.6-.35,1.08-.1,1.08.54a2.31,2.31,0,0,1-1.08,1.8l-71,41c-.6.35-1.08.1-1.08-.54A2.31,2.31,0,0,1,220.66,199.57Z",
    style: {
      fill: "#e0e0e0",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,206.62l71-41c.6-.34,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8l-71,41c-.6.34-1.08.1-1.08-.55A2.32,2.32,0,0,1,220.66,206.62Z",
    style: {
      fill: "#e0e0e0",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,236.5l71-41c.6-.35,1.08-.1,1.08.54a2.31,2.31,0,0,1-1.08,1.8l-71,41c-.6.35-1.08.1-1.08-.55A2.3,2.3,0,0,1,220.66,236.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,243.53l71-41c.6-.34,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8l-71,41c-.6.34-1.08.1-1.08-.55A2.32,2.32,0,0,1,220.66,243.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,250.57l71-41c.6-.35,1.08-.1,1.08.54a2.31,2.31,0,0,1-1.08,1.8l-71,41c-.6.35-1.08.1-1.08-.54A2.31,2.31,0,0,1,220.66,250.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,257.62l71-41c.6-.34,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8l-71,41c-.6.34-1.08.1-1.08-.55A2.32,2.32,0,0,1,220.66,257.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,236.5l71-41c.6-.35,1.08-.1,1.08.54a2.31,2.31,0,0,1-1.08,1.8l-71,41c-.6.35-1.08.1-1.08-.55A2.3,2.3,0,0,1,220.66,236.5Z",
    style: {
      fill: "#e0e0e0",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,243.53l71-41c.6-.34,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8l-71,41c-.6.34-1.08.1-1.08-.55A2.32,2.32,0,0,1,220.66,243.53Z",
    style: {
      fill: "#e0e0e0",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,250.57l71-41c.6-.35,1.08-.1,1.08.54a2.31,2.31,0,0,1-1.08,1.8l-71,41c-.6.35-1.08.1-1.08-.54A2.31,2.31,0,0,1,220.66,250.57Z",
    style: {
      fill: "#e0e0e0",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,257.62l71-41c.6-.34,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8l-71,41c-.6.34-1.08.1-1.08-.55A2.32,2.32,0,0,1,220.66,257.62Z",
    style: {
      fill: "#e0e0e0",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,288.5l71-41c.6-.35,1.08-.1,1.08.54a2.31,2.31,0,0,1-1.08,1.8l-71,41c-.6.35-1.08.1-1.08-.55A2.3,2.3,0,0,1,220.66,288.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,295.53l71-41c.6-.34,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8l-71,41c-.6.34-1.08.1-1.08-.55A2.32,2.32,0,0,1,220.66,295.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,302.57l71-41c.6-.35,1.08-.1,1.08.54a2.31,2.31,0,0,1-1.08,1.8l-71,41c-.6.35-1.08.1-1.08-.54A2.31,2.31,0,0,1,220.66,302.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,309.62l71-41c.6-.34,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8l-71,41c-.6.34-1.08.1-1.08-.55A2.32,2.32,0,0,1,220.66,309.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,288.5l71-41c.6-.35,1.08-.1,1.08.54a2.31,2.31,0,0,1-1.08,1.8l-71,41c-.6.35-1.08.1-1.08-.55A2.3,2.3,0,0,1,220.66,288.5Z",
    style: {
      fill: "#e0e0e0",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,295.53l71-41c.6-.34,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8l-71,41c-.6.34-1.08.1-1.08-.55A2.32,2.32,0,0,1,220.66,295.53Z",
    style: {
      fill: "#e0e0e0",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,302.57l71-41c.6-.35,1.08-.1,1.08.54a2.31,2.31,0,0,1-1.08,1.8l-71,41c-.6.35-1.08.1-1.08-.54A2.31,2.31,0,0,1,220.66,302.57Z",
    style: {
      fill: "#e0e0e0",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,309.62l71-41c.6-.34,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8l-71,41c-.6.34-1.08.1-1.08-.55A2.32,2.32,0,0,1,220.66,309.62Z",
    style: {
      fill: "#e0e0e0",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.31,220.29,226,217.6c1-.55,1.73-.1,1.73,1V224a3.81,3.81,0,0,1-1.73,3l-4.66,2.69c-1,.55-1.73.11-1.73-1v-5.38A3.82,3.82,0,0,1,221.31,220.29Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.31,220.29,226,217.6c1-.55,1.73-.1,1.73,1V224a3.81,3.81,0,0,1-1.73,3l-4.66,2.69c-1,.55-1.73.11-1.73-1v-5.38A3.82,3.82,0,0,1,221.31,220.29Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.93,215.35l28.16-16.26c1.2-.69,2.17-.2,2.17,1.09a4.64,4.64,0,0,1-2.17,3.6L233.93,220c-1.2.69-2.17.2-2.17-1.09A4.64,4.64,0,0,1,233.93,215.35Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.93,215.35l28.16-16.26c1.2-.69,2.17-.2,2.17,1.09a4.64,4.64,0,0,1-2.17,3.6L233.93,220c-1.2.69-2.17.2-2.17-1.09A4.64,4.64,0,0,1,233.93,215.35Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.31,271.89,226,269.2c1-.56,1.73-.11,1.73,1v5.38a3.82,3.82,0,0,1-1.73,3l-4.66,2.69c-1,.55-1.73.1-1.73-1v-5.38A3.81,3.81,0,0,1,221.31,271.89Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.31,271.89,226,269.2c1-.56,1.73-.11,1.73,1v5.38a3.82,3.82,0,0,1-1.73,3l-4.66,2.69c-1,.55-1.73.1-1.73-1v-5.38A3.81,3.81,0,0,1,221.31,271.89Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.93,267l28.16-16.27c1.2-.69,2.17-.2,2.17,1.1a4.65,4.65,0,0,1-2.17,3.6l-28.16,16.26c-1.2.69-2.17.2-2.17-1.1A4.64,4.64,0,0,1,233.93,267Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.93,267l28.16-16.27c1.2-.69,2.17-.2,2.17,1.1a4.65,4.65,0,0,1-2.17,3.6l-28.16,16.26c-1.2.69-2.17.2-2.17-1.1A4.64,4.64,0,0,1,233.93,267Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.94,317.31l4.66-2.69c1-.55,1.74-.1,1.74,1V321a3.82,3.82,0,0,1-1.74,3l-4.66,2.69c-.95.56-1.73.11-1.73-1v-5.38A3.86,3.86,0,0,1,227.94,317.31Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,335.59l19.23-11.1c.6-.34,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8l-19.23,11.1c-.6.34-1.08.1-1.08-.55A2.32,2.32,0,0,1,220.66,335.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.81,302.37l4.66-2.69c.95-.55,1.73-.1,1.73,1v5.38a3.83,3.83,0,0,1-1.73,3l-4.66,2.69c-1,.55-1.74.11-1.74-1v-5.38A3.83,3.83,0,0,1,253.81,302.37Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.52,320.65l19.23-11.1c.6-.35,1.08-.1,1.08.55a2.3,2.3,0,0,1-1.08,1.79L246.52,323c-.6.35-1.08.1-1.08-.54A2.31,2.31,0,0,1,246.52,320.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.67,287.43l4.66-2.69c.95-.56,1.73-.11,1.73,1v5.38a3.85,3.85,0,0,1-1.73,3l-4.66,2.69c-1,.55-1.73.1-1.73-1v-5.38A3.81,3.81,0,0,1,279.67,287.43Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.94,317.31l4.66-2.69c1-.55,1.74-.1,1.74,1V321a3.82,3.82,0,0,1-1.74,3l-4.66,2.69c-.95.56-1.73.11-1.73-1v-5.38A3.86,3.86,0,0,1,227.94,317.31Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.81,302.37l4.66-2.69c.95-.55,1.73-.1,1.73,1v5.38a3.83,3.83,0,0,1-1.73,3l-4.66,2.69c-1,.55-1.74.11-1.74-1v-5.38A3.83,3.83,0,0,1,253.81,302.37Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.67,287.43l4.66-2.69c.95-.56,1.73-.11,1.73,1v5.38a3.85,3.85,0,0,1-1.73,3l-4.66,2.69c-1,.55-1.73.1-1.73-1v-5.38A3.81,3.81,0,0,1,279.67,287.43Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.38,305.71l19.23-11.1c.6-.35,1.08-.1,1.08.54a2.31,2.31,0,0,1-1.08,1.8l-19.23,11.1c-.59.35-1.08.1-1.08-.55A2.33,2.33,0,0,1,272.38,305.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.09,138.86c-11.22,6.32-20.31,22.07-20.31,35.17s9.09,18.48,20.31,12,20.31-22.22,20.31-35.18S188.3,132.53,177.09,138.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.09,138.86c-11.22,6.32-20.31,22.07-20.31,35.17s9.09,18.48,20.31,12,20.31-22.22,20.31-35.18S188.3,132.53,177.09,138.86Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.09,138.86c-11.22,6.32-20.31,22.07-20.31,35.17s9.09,18.48,20.31,12,20.31-22.22,20.31-35.18S188.3,132.53,177.09,138.86Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.93,179.23l-16.26,4.36a1.77,1.77,0,0,1-2.31-1.86V154.05A11.1,11.1,0,0,1,176,143.78l5.56-1.49c4.23-1.13,7.66,1.63,7.66,6.16v27.69A3.35,3.35,0,0,1,186.93,179.23Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.71,186.39,186,178.84s0-10.19-1.45-11.13-1.87-1.12-1.87-1.12c1.86-.64,5.78-1.12,7,2.46,1.17,3.38,2.92,11.71,3.75,15.81Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.57,186.43l-5.8-19.75c2.57-1,5.87-1.83,7.47.82,1.44,2.38,3.74,14.85,4.19,17.36Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M187.57,186.43l-5.8-19.75c2.57-1,5.87-1.83,7.47.82,1.44,2.38,3.74,14.85,4.19,17.36Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M188.35,186.22l-5.7,1.53a13,13,0,0,1,1.59-4.65,9.28,9.28,0,0,1,4.68-3.51A33.32,33.32,0,0,0,188.35,186.22Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.35,186.22l-5.7,1.53a13,13,0,0,1,1.59-4.65,9.28,9.28,0,0,1,4.68-3.51A33.32,33.32,0,0,0,188.35,186.22Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M188.35,186.22l-5.7,1.53a13,13,0,0,1,1.59-4.65,9.28,9.28,0,0,1,4.68-3.51A33.32,33.32,0,0,0,188.35,186.22Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M187.13,186.55l-16,4.27-1.76-5.45s4.67-10.93-1.1-13.74c.73-.55,6.88-2.95,6.88-2.95l6.61-2c1.26-.34,6.35,1.92,7.64,6.93.46,1.77.3,3.36-2.29,12.58C187.14,186.31,187.13,186.43,187.13,186.55Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.81,145.69c1.1.4,2.46,3,2.33,9.27-.11,5.32-1.71,7-2.51,7.64a8.6,8.6,0,0,1-3.86.91v3.17s2.08,2,1.95,3.52-3,2.6-4.94,1.7a11.16,11.16,0,0,1-3.59-3.22l0-7.3a1.68,1.68,0,0,1-2.39.15,2.83,2.83,0,0,1-.69-4c1-1.31,2.75-1.5,3.43-.19a9.87,9.87,0,0,1,4.3-4.85C183,150.57,184.72,148.86,185.81,145.69Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.64,155.11a.92.92,0,0,1-.59.88.49.49,0,0,1-.65-.48.92.92,0,0,1,.59-.88A.49.49,0,0,1,182.64,155.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.8,159.55l1.44.1a1,1,0,0,1-.93.81C182.91,160.43,182.68,160,182.8,159.55Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.72,151.71l-1.25-.59a.84.84,0,0,1,1-.51A.79.79,0,0,1,187.72,151.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.84,154.05l1.25-1.27a.67.67,0,0,0-1,.05A1,1,0,0,0,180.84,154.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.43,153.35a.91.91,0,0,1-.59.88.49.49,0,0,1-.65-.49.93.93,0,0,1,.59-.88A.49.49,0,0,1,187.43,153.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.51 153.75 184.6 157.72 186.57 156.54 184.51 153.75",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.77,163.51c-1.58.2-4.84.07-5.35-1.17a2.54,2.54,0,0,0,1.14,1.45c1,.64,4.21.78,4.21.78Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.22 190.81 170.55 188.43 172.31 190.52 171.22 190.81",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.91,191.16A70.19,70.19,0,0,0,167,181.1c-1.68-4.61.2-8.59,1.33-9.47s6.88-2.95,6.88-2.95c2.08,5.92,2.65,13.85,2.7,20.34Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.91,191.16A70.19,70.19,0,0,0,167,181.1c-1.68-4.61.2-8.59,1.33-9.47s6.88-2.95,6.88-2.95c2.08,5.92,2.65,13.85,2.7,20.34Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.07,191.92l-5.71,1.53a3.51,3.51,0,0,1-.45-.36s2.7-10.42,3.56-13.88,1.52-5.84,3.84-7.58c4.17,2.71,2.24,10.24,2.24,10.24Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.07,191.92l-5.71,1.53a3.51,3.51,0,0,1-.45-.36s2.7-10.42,3.56-13.88,1.52-5.84,3.84-7.58c4.17,2.71,2.24,10.24,2.24,10.24Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.09,138.86c-11.22,6.32-20.31,22.07-20.31,35.17s9.09,18.48,20.31,12,20.31-22.22,20.31-35.18S188.3,132.53,177.09,138.86Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.09,138.86c-11.22,6.32-20.31,22.07-20.31,35.17s9.09,18.48,20.31,12,20.31-22.22,20.31-35.18S188.3,132.53,177.09,138.86Z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--graduation-cap--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.93,125.33V105.52h0c-.06-3.84,2.44-7.69,7.51-10.61,10-5.79,26.26-5.79,36.28,0,5.07,2.92,7.57,6.77,7.51,10.61h0v19.74c0,3.82-2.46,10.65-7.51,13.56-10,5.79-26.26,5.79-36.28,0-5-2.88-7.5-9.66-7.51-13.45h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.58 80.94 151.91 105.38 109.58 129.82 67.25 105.38 109.58 80.94",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4,117.59l20.85-11.9A.75.75,0,0,1,110,107L89.89,118.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.91 105.38 151.91 107.13 109.58 131.56 109.58 129.82 151.91 105.38",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.25 105.38 67.25 107.13 109.58 131.56 109.58 129.82 67.25 105.38",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.35,118.73l1.29.74a2.24,2.24,0,0,1,.79-.77l.45-.26-1.47-.84A3.46,3.46,0,0,0,87.35,118.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.28 116.73 109.58 134.18 83.95 116.77 109.58 131.56 135.28 116.73",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7,139.31a2.53,2.53,0,0,0,2.32,0l1.91,12.33c0,2.33-6.05,2.33-6.05,0Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.59,146.35l-.38,6.76a1.94,1.94,0,0,1-.36-.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.45,153.16l-.8-11L88.84,153A3.54,3.54,0,0,1,88.45,153.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.09,153.38h-.38l.2-8.73Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.85,140.34a2.17,2.17,0,0,0,1.23-.42.74.74,0,0,0,.18-1,.73.73,0,0,0-1-.19.51.51,0,0,1-.71,0,.75.75,0,1,0-.89,1.2A2.06,2.06,0,0,0,86.85,140.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9,138.42a.74.74,0,0,0,.75-.74V120.2a2.25,2.25,0,0,1,1.12-1.94L110,106.16a.74.74,0,0,0,.28-1,.73.73,0,0,0-1-.28L88,117a3.74,3.74,0,0,0-1.87,3.23v17.48A.74.74,0,0,0,86.9,138.42Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.54,137.68a1.64,1.64,0,1,0-1.64,1.63A1.63,1.63,0,0,0,88.54,137.68Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.28,137.77a1.27,1.27,0,0,0,1.82.62,1.36,1.36,0,0,0,0-2.33,1.63,1.63,0,1,1-1.85,1.71Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "376.61 128.03 368.88 123.58 373.13 122.68 377.36 125.63 376.61 128.03",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.08,88.2c0-12-7.35-17.57-16.38-12.36l-13.34,7.7c-9,5.21-16.37,19.25-16.37,31.29,0,.49,0,1,0,1.43,0,.27,0,.5,0,.76s.05.47.07.7.06.53.1.79a19.76,19.76,0,0,0,1.06,4.16c.21.5.43,1,.67,1.42a5.51,5.51,0,0,0,.38.67l.13.21a6.31,6.31,0,0,0,.77,1c.16.18.31.37.48.54l.52.5c.18.14.35.31.54.45a4.42,4.42,0,0,0,.57.39l.59.34a7.72,7.72,0,0,0,2.45.83.42.42,0,0,1,.2,0c.23,0,.44.05.67.05a4.45,4.45,0,0,0,.73,0,8,8,0,0,0,1.91-.21,11.27,11.27,0,0,0,1.11-.28v0a15.28,15.28,0,0,0,3.34-1.48l13.34-7.7a22.44,22.44,0,0,0,2.62-1.78c0-.16,0-.3,0-.45s0-.47,0-.65c0-.4,0-.81,0-1.22C349.21,105.07,355.37,93,363.08,88.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.33,79.55l-7.75-4.46c.05,0,.79,5.39.79,5.39l5.75.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.52 131.96 322.36 127.9 326.67 126.05 329.52 131.96",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.36,127.22a14.59,14.59,0,0,1-2.73,8.25c-.32.42.17.79.53.6a13.82,13.82,0,0,0,4.26-3.43,21.71,21.71,0,0,0,4.61-9.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.71,136.05l7.75,4.46s4.35-3.67,4.35-11.1l-8.41-.57S334.2,133.68,330.71,136.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.35,114.19q0,.56,0,1.08c0,.2,0,.37,0,.56s0,.35.06.53,0,.4.07.6a12.87,12.87,0,0,0,.62,2.6,3.43,3.43,0,0,0,.16.45,6.14,6.14,0,0,0,.25.59,4.53,4.53,0,0,0,.27.54,3.41,3.41,0,0,0,.28.5l.1.16a7.64,7.64,0,0,0,.58.79,3.52,3.52,0,0,0,.36.41l.38.37a4.35,4.35,0,0,0,.41.34,4,4,0,0,0,.43.29c.15.09.29.18.45.26l.46.22.48.17h0a8.89,8.89,0,0,0,.89.22l.15,0a2.74,2.74,0,0,0,.5,0,2.4,2.4,0,0,0,.54,0,6.39,6.39,0,0,0,1.28-.13,8.84,8.84,0,0,0,1-.23,11.56,11.56,0,0,0,2.51-1.11l10-5.78a16.06,16.06,0,0,0,2.51-1.79h0c.28-.24.56-.5.84-.76a18.46,18.46,0,0,0,1.43-1.49L379,113c.17-.2.33-.41.5-.62a1,1,0,0,1,.15-.2,28.61,28.61,0,0,0,1.84-2.75c.15-.25.29-.51.44-.77s.29-.52.43-.79.27-.54.41-.8l.38-.82c.13-.27.25-.56.37-.82.21-.48.4-1,.57-1.46,0-.09.07-.18.1-.27.11-.28.2-.56.29-.84.18-.54.34-1.08.5-1.64a30.64,30.64,0,0,0,.79-4c0-.23.05-.45.08-.68s0-.39.05-.59,0-.4,0-.6q0-.56,0-1.11c0-9-5.51-13.21-12.29-9.3l-10,5.79C356.86,94.62,351.35,105.15,351.35,114.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.51 88.78 381.82 84.36 378.92 86.41 387.89 91.84 389.51 88.78",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.11 128.45 355.38 124 361.44 122.19 363.11 128.45",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.13,118.59c0,1.6,2,3.78,4.29,4.19.31.06.23.74-.14,1a6.92,6.92,0,0,1-4.47.74,5.61,5.61,0,0,1-4.8-3Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.44,80.29,341.09,88c-9,5.21-16.36,19.25-16.36,31.28,0,.5,0,1,0,1.44,0,.27,0,.5,0,.76s.05.46.08.69.06.55.1.8a19.51,19.51,0,0,0,1,4.15c.21.51.43,1,.67,1.43a5.19,5.19,0,0,0,.38.66,1.91,1.91,0,0,0,.14.21,6.51,6.51,0,0,0,.76,1.06c.16.18.32.38.49.54l.51.5c.18.14.36.31.54.45a5.23,5.23,0,0,0,.57.39l.6.34a7.75,7.75,0,0,0,2.44.83.31.31,0,0,1,.2,0c.23,0,.45,0,.67,0a6,6,0,0,0,.73,0,8.46,8.46,0,0,0,1.91-.21,11.27,11.27,0,0,0,1.11-.28v0a16,16,0,0,0,3.34-1.47h0a14.49,14.49,0,0,1-2.74,8.24c-.32.43.17.8.54.61a13.73,13.73,0,0,0,4.26-3.44,21.85,21.85,0,0,0,4.61-9.26l-1,.55,7.63-4.4a20.61,20.61,0,0,0,2.13-1.41,6.51,6.51,0,0,1-.13-.77c0-.17-.06-.42-.08-.68a5.77,5.77,0,0,1-.07-.67v-.12a4.19,4.19,0,0,1,0-.5c0-.38,0-.78,0-1.18,0-10.12,6-21.53,13.72-26l.85-.5C370.61,80.47,363.34,75.15,354.44,80.29Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.39,89.37l-10,5.78c-6.77,3.92-12.29,14.45-12.29,23.49,0,.37,0,.73,0,1.08s0,.37,0,.56,0,.35.05.53a5.59,5.59,0,0,0,.08.59,12.18,12.18,0,0,0,.62,2.61,2.41,2.41,0,0,0,.16.45,5,5,0,0,0,.24.58,5.64,5.64,0,0,0,.27.55,3.45,3.45,0,0,0,.29.5.76.76,0,0,0,.09.16c.19.28.38.54.58.79a4.89,4.89,0,0,0,.37.41l.38.37a4.35,4.35,0,0,0,.41.34,3.13,3.13,0,0,0,.42.29c.15.09.29.18.45.26l.46.22.48.17h0a8.89,8.89,0,0,0,.89.22l.15,0a2.74,2.74,0,0,0,.5,0,2,2,0,0,0,.55,0,6.49,6.49,0,0,0,1.28-.12,9.22,9.22,0,0,0,1-.23,11.15,11.15,0,0,0,2.51-1.11l3.38-1.94a5.61,5.61,0,0,0,4.8,2.95,6.93,6.93,0,0,0,4.47-.75c.36-.23.45-.91.13-1-2.29-.41-4.28-2.59-4.28-4.19l1.52-.88a16.54,16.54,0,0,0,2.51-1.79h0c.28-.24.56-.5.83-.76a18.56,18.56,0,0,0,1.44-1.49c.18-.21.36-.41.54-.65s.33-.4.5-.61l.15-.2a28.61,28.61,0,0,0,1.84-2.75l.45-.77c.15-.26.29-.52.43-.79s.26-.54.4-.8l.39-.82c.13-.28.24-.56.36-.82.21-.48.41-1,.58-1.46l.09-.27c.11-.28.21-.56.29-.84.19-.55.34-1.08.51-1.64a30.64,30.64,0,0,0,.79-4c0-.23.05-.45.07-.68s0-.4.05-.59,0-.4,0-.6c0-.37,0-.75,0-1.12C393.68,89.63,388.16,85.46,381.39,89.37Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.05,221.65c-3.78-1.18-7.66,1.88-10.2,8.06s-7.87,21.9-8.66,26.09,17.09,13.31,16.59,13.07S301.05,221.65,301.05,221.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.74,367.11c-.54.2-.67,1.22-.75,3.24-.06,1.53-.39,4.2,1.4,4.73s4.42.26,5.57-1.18c1.43-1.8,2.4-3.38,4.44-5.58,1.78-1.9,3.69-3.68,4.41-6.35.65-2.42.11-3.46-1.54-4.16-2.26-1-5.82,2.18-7.59,2.68C297.15,360.92,293.27,366.91,292.74,367.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.74,365.24v2.48a6.08,6.08,0,0,0,6.27.17c.11-.24.65-3.55.65-3.55Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.83,381.41s-.71,2.16-1.09,4c-.31,1.5-.74,4-.22,5.14s2.58,1.86,5.75,1.83c2.06,0,5.27,1.39,7.46,2.61s7,1.77,9.39,1.49c2.82-.33,5.75-2,6.21-3.14s-.15-2.39-6.81-5.23c-.06,0-9.26-3-12.49-6.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.83,378.73s0,1.84,0,2.89,1.24,2.62,4.46,2.51c2.26-.08,3.83-.69,3.74-2.55v-2.69Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.12,332.31a67.94,67.94,0,0,1,2.93-12.93s-.88-11.15-1.31-21.72c-.46-11.42,0-25.78-.19-28.62,0,0,36.85-7.46,37.51,5.74s-1.46,46.8-1.89,52.6-1.44,10.93-2.64,20.33-4.5,31.18-4.5,31.18a8.7,8.7,0,0,1-8.2-.16s-2.59-26.4-2.32-33.09A57.57,57.57,0,0,1,313.05,331l-1.31-20.35c-.62-9.47-1.27-14-1.42-18.13l-.79-.4s-.81,16.34-1.24,22.14-1.36,11.36-3,22.13c-1.46,9.34-5.79,29.11-5.79,29.11-4.21,2.28-6.72-.29-6.72-.29S290,340.41,291.12,332.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.32,292.55s-8.94-4.41-13.41-8.38c0,0,4.15,5.85,9.61,8.45,0,0,1.94,20.29,1.93,19.89l1.12-20Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.28 217.47 316.1 229.47 305.26 228.68 307.53 215.07 318.28 217.47",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.81,227.8c1.07-3.26,5.21-6.81,9.35-6a121.59,121.59,0,0,1,18.15,4.53c3.79,1.35,7.24,4.63,7.56,17.11l1.92,37.16-4.59,1-1.6-8.42-.74,8.42c-4.8,1.2-13.13.21-18.6-1-11.4-2.49-12.77-7.22-12.77-7.22s-.15-20.91.19-29.94C293,235.72,293.07,230,293.81,227.8Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.3,203.25s2.63,3.89,2.29,4.3a6,6,0,0,1-2,.87Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.28,190.93c2.53,1.28,6.9,3.64,8.1,12.89,1.24,9.5-.39,12.56-1.67,13.82-.87.85-5.59.9-7.95.19-3-.89-9.62-3.42-12.66-8.3-3.58-5.74-4.38-13.43-.34-16.49C309.43,188.74,316.14,189.85,318.28,190.93Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.91,194.11c-.83,2.28-2.23,7.86-8.05,10.19,0,0-.83-3.56-3.82-3.18s-3.5,4.19-1.66,6.56,3.62,1.51,3.62,1.51.4,5.1-3,7.41c0,0-4.11,2.6-8.46.6-2-.9-4.73-5.59-6.35-9.44-3.44-8.14-3.93-14.67,1.26-16.73.64-3.7,2.31-5.09,5.66-5.78,7.21-1.49,12.66,3.25,18.72,2.42C328,187.23,327.86,191.51,326.91,194.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.33,192.27l-3.4-2.1a2,2,0,1,1,3.4,2.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.48,221.84l1.24,3.59s-.91,1.6-4.78,1.68-8-1.15-9.28-2.8a2.93,2.93,0,0,1-.72-2.41s1.54-3.4,3-3.25l-.24,1.48s.33,1.21,3.84,2.14C316,223.72,317.48,221.84,317.48,221.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.58,245.7c1.56-1.79,2.16-5.76,4.24-8.48s2.85-4.71,3.67-3.52c1.09,1.57-1.37,4.72-.82,5s2.58,4.46,2.79,6.76-5.89,8.1-5.89,8.1Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.48,221.84a1.39,1.39,0,0,1,1.24.71,32.92,32.92,0,0,1,1.64,3.41l-1.64-.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.5,238.38s7.37-.64,8.44,0,.75,3.83,0,5.79-4.51,3.23-8,5.59C355.94,249.4,355.5,238.38,355.5,238.38Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.36,226c3.17,1.11,5.94,2.38,8.9,7.94,3.8,7.14,11,18.56,11,18.56l8.29-7.31s1.25-1.21,3.58,2.64a8,8,0,0,1,.85,7.1s-9.57,11.23-11.4,12.94-4.86.38-6.83-2.31-14.42-18.24-14.42-18.24S313.57,238.34,320.36,226Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.26,155.33h23.61a3.36,3.36,0,0,1,3.36,3.36V196.2a11.13,11.13,0,0,1-11.13,11.13H390A11.13,11.13,0,0,1,378.9,196.2V158.69A3.36,3.36,0,0,1,382.26,155.33Z",
    transform: "translate(788.13 362.66) rotate(180)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.28,194.53c-2.29,6.75-6.13,26.17-6.13,26.17s-8,9.78-10.61,12.15c-1.43,1.32-4.65,3.69-4.65,3.69l5.85,4.3a129.87,129.87,0,0,0,14.84-13.35,8.49,8.49,0,0,0,2.08-3.88l4-17.16s0-13.8,2.11-15.61,2.72-2.19,2.72-2.19C385.78,188.45,380.08,189.22,378.28,194.53Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.74,188.45c-3.73-.43-8.51-.35-10.84,3.82S372.69,218,372.69,218s3.67,2.85,7.63,2.8Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.37,208.54a38.6,38.6,0,0,1,.77,9.78c-.29,4.32-3.27,11.86-3.27,11.86s2.33,2.56,8.9,1.53c5.35-.83,3.46-17,.39-20.1A10.12,10.12,0,0,0,379.37,208.54Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.37,208.54a38.6,38.6,0,0,1,.77,9.78c-.29,4.32-3.27,11.86-3.27,11.86s2.33,2.56,8.9,1.53c5.35-.83,3.46-17,.39-20.1A10.12,10.12,0,0,0,379.37,208.54Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.73,322.74a3.61,3.61,0,0,1-.53,2.1,26.42,26.42,0,0,1-3.47,4.54c-1.85,2-4.62,4.35-6.61,6.08-1.1,1-1.14,2.42.44,2.93a11.91,11.91,0,0,0,8.69-1.21c2-1.06,4.78-6,6.42-6.7,1.89-.85,2.94-1.27,3.58-2.14a3.06,3.06,0,0,0,.39-3.79c-.89-1.66-2.23-4.21-2.78-3.92l.17.52c-.43,1.35-4.11,2.92-6,2.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411,266.32c.85-9,3.29-23.48.79-34.2l-33.2,1.76c-.92,10.57-2,43.57-.84,47.35,1.34,4.46,13.31,35.33,14,41.54a3.44,3.44,0,0,1-.53,2.07,26.33,26.33,0,0,1-3.47,4.55c-.9,1-2,2-3.16,3a1,1,0,0,0-.17.48c0,1,2.52,1.31,4,.88a9.21,9.21,0,0,0,4.54-3.49c.85-1.13,2.76-3.3,4-4.93a8.21,8.21,0,0,0,1.05-1.64,3.35,3.35,0,0,0,.16-2.33l-.08-.25a26.49,26.49,0,0,1-1.2-6.24c-.46-6.81-1.63-22.54-2.71-26.73a36.67,36.67,0,0,0-3.39-8.76l3.79-29.49s.4,26,1.58,32.63c.93,5.31,1.29,11.95,2.38,21.06,1,8.72,2.16,24.08,2.16,24.08a.25.25,0,0,0,.09,0V335H407v-4.26a34.56,34.56,0,0,1,.48-5.74c1-5.8,3.08-19.07,3.51-23.56.68-7.12-1.89-16.07-1.89-16.07S410.17,275.1,411,266.32Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.3,188.76s8.93,1,10,1.51c-8.38,5.89-1.59,19-1.59,19l-3.21,10.07c3.57,4.57,6.65,7.29,8.56,12.3,2.12,5.6,4,13.93,3.5,31-8,6-32.34,5.35-41.82,0,0,0,1.6-15.07,3.49-26.78,1.25-7.73,4.2-16.15,3.7-19-3.76-11.56-4-13.64-3.32-16.22,1.87-7.26,9.27-12.17,11.09-12.17Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.3,188.76s8.93,1,10,1.51c-8.38,5.89-1.59,19-1.59,19l-3.21,10.07c3.57,4.57,6.65,7.29,8.56,12.3,2.12,5.6,4,13.93,3.5,31-8,6-32.34,5.35-41.82,0,0,0,1.6-15.07,3.49-26.78,1.25-7.73,4.2-16.15,3.7-19-3.76-11.56-4-13.64-3.32-16.22,1.87-7.26,9.27-12.17,11.09-12.17Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.73,331.89V331a17.46,17.46,0,0,1-4.52,7.91c-2,1.81-4.7,3.91-5.4,5.94s3.21,2.94,5.79,2.68a10.37,10.37,0,0,0,6.48-3.39c1.64-1.88,1.61-3.16,2.37-4.2s2.53-2.18,2.94-3.38a7.59,7.59,0,0,0-.36-3.32c-.29-1.11-.61-2.34-1-2.24v.69a5,5,0,0,1-3.16,1.07C403,332.78,400.72,332.59,400.73,331.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,331.67a5,5,0,0,1-3.16,1.07c-.92,0-3.16-.15-3.15-.85V331a17.46,17.46,0,0,1-4.52,7.91l-1.51,1.35c-1.06,1.18-.76,2.21,1.73,2.42s4.68-1.29,6.56-3.6A40.76,40.76,0,0,0,407,331.67Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.88,161.46c-1.6.95-3.58,5-3.39,13.42.17,7.16,2.49,8.93,3.66,9.44s3.41.2,5.59-.16v4.29s-3,3.51-2.83,5.48,4.36,2.43,7.19.51a22.77,22.77,0,0,0,5.2-5.68l-.05-9.87s1.29,1.24,3.47-.66c1.8-1.57,2.4-4.23,1-5.65a3.13,3.13,0,0,0-5,1s-1.21-3.37-6.24-5C387.94,167.07,385.47,165.36,383.88,161.46Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.49,173.09a.9.9,0,1,0,.94-.9A.92.92,0,0,0,388.49,173.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.25,179.15l-2.09.67a1.07,1.07,0,0,0,1.35.75A1.16,1.16,0,0,0,388.25,179.15Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.11,170.32l1.82-1.26a1.07,1.07,0,0,0-1.52-.31A1.15,1.15,0,0,0,381.11,170.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.11,171l-1.83-1.26a1.08,1.08,0,0,1,1.52-.32A1.18,1.18,0,0,1,391.11,171Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.53,172.43a.9.9,0,1,0,.94-.89A.92.92,0,0,0,381.53,172.43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.77 171.92 385.63 177.34 382.78 176.46 385.77 171.92",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.74,184.16c2.3-.31,7-1.67,7.78-3.54a4.87,4.87,0,0,1-1.66,2.39c-1.42,1.21-6.12,2.58-6.12,2.58Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.05 213.85 399.74 222.39 404.5 219.34 406.05 213.85",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.34,236.54c-1.35,1.74-2.18,5.12-2.89,6.26s-1.56,2.13,0,2.34,3.84-2.84,4.69-4.69a4.44,4.44,0,0,1,2.27-2.35c-.73-.25-.35-3.18-.86-3.59C359.55,234.51,356.89,235.6,356.34,236.54Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.94,249.74c1.41-1.05,1.46-2.34,1.73-4.39s5.92-4.27,6.1-2.74.69,2.81-1,4.67S358.52,251.12,355.94,249.74Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.3,188.76s8.36.73,10,1.51,4.37,5.5,1.93,12.35-4.66,14.91-4.41,16.53,6.08,10,6.08,10a15.84,15.84,0,0,1-5.36,2.57l-3-6.52.7,6.93a35.63,35.63,0,0,1-9.21,1S393.2,206.51,399.3,188.76Z",
    style: {
      fill: "#6860EE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.9,221.41c.67-3.94,0-5.23-1.38-9.09l-7,4.53a14.7,14.7,0,0,1,1,4.56c-.06,1.14-1.61,12.44-3.06,16.38a3,3,0,0,1-1.44,1.62,17.51,17.51,0,0,0-3.88,3.22c-1.07,1-1.93,1.18-1.82,1.52a1.64,1.64,0,0,0,2,.89,11.9,11.9,0,0,0,2.49-1.14,15.27,15.27,0,0,1-2.74,4c-2.57,2.74-2.8,4.52,2,4.89,3,.23,5.51-1.45,8.22-7.9a60.28,60.28,0,0,0,2.07-7.23C417.82,232.07,419.24,225.38,419.9,221.41Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.3,190.27c3.37,1.51,4.33,4.49,5.58,8.87s5.17,17.52,5.17,17.52-3.36,4-8,2.88l-6-14.57S403.25,195.46,409.3,190.27Z",
    style: {
      fill: "#6860EE"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchPrecision);
export default __webpack_public_path__ + "static/media/match-precision.fff33b0eaa377bc72269d73b80ba2a5a.svg";
export { ForwardRef as ReactComponent };